// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        // Optional
        loadProductFirst: true,
        numberFilterTree: 2
    }
};

// Declare Templates
var bcSfFilterTemplate = {
    'soldOutClass': 'sold-out',
    'onSaleClass': 'on-sale',

    'soldOutLabelHtml': '<div class="badge badge--sold-out"><span class="badge-label">' + bcSfFilterConfig.label.sold_out + '</span></div>',

    // Grid
    'productGridItemHtml': '<div class="grid-item {{gridItemWidthClass}} {{soldOutClass}} {{onSaleClass}} {{otpShow}}">' +
                                
                                '<a href="{{itemUrl}}" class="product-grid-item">' +
                                    '<div class="product-grid-image">' +
                                        '<div class="product-grid-image--centered">' +
//                                             '{{itemSoldOutLabel}}' +
                                            '{{itemImg}}' +
                                        '</div>' +
                                    '</div>' +
                                    '<p>{{itemTitle}}</p>' +
                                    '<div class="product-item--price">' +
//                                         '{{itemPrice}}' +
                                    '</div>' +
                                '</a>' +
                            '</div>',

    // List
    'productListItemHtml': '<div class="grid-item {{soldOutClass}} {{onSaleClass}}">' +
                                '<a href="{{itemUrl}}" class="product-grid-item product-list-item">' +
                                    '<div class="grid">' +
                                        '<div class="grid-item large--one-fifth medium--one-third">' +
                                            '<div class="product-list-image">' +
//                                                 '{{itemSoldOutLabel}}' +
                                                '<img src="{{itemThumbUrl}}" alt="{{itemTitle}}" />' +
                                            '</div>' +
                                        '</div>' +
                                        '<div class="grid-item large--three-fifths medium--two-thirds">' +
                                            '<p class="h6">{{itemTitle}}</p>' +
                                            '<div class="rte">' +
                                                '<p>{{itemDescription}}</p>' +
                                            '</div>' +
                                        '</div>' +
                                        '<div class="grid-item large--one-fifth medium--two-thirds">' +
                                            '<div class="product-item--price text-center">' +
//                                                 '{{itemPrice}}' +
                                            '</div>' +
                                        '</div>' +
                                    '</div>' +
                                '</a>' +
                            '</div>',

    // Pagination Template
    'previousActiveHtml': '<li><a href="{{itemUrl}}">&larr;</a></li>',
    'previousDisabledHtml': '<li class="disabled"><span>&larr;</span></li>',
    'nextActiveHtml': '<li><a href="{{itemUrl}}">&rarr;</a></li>',
    'nextDisabledHtml': '<li class="disabled"><span>&rarr;</span></li>',
    'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li><span class="active">{{itemTitle}}</span></li>',
    'pageItemRemainHtml': '<li><span>{{itemTitle}}</span></li>',
    'paginateHtml': '<ul class="pagination-custom">{{previous}}{{pageItems}}{{next}}</ul>',

    // Sorting Template
    'sortingHtml': '<div class="form-horizontal"><label>' + bcSfFilterConfig.label.sorting + '</label><select>{{sortingItems}}</select></div>',

    // Display Type Template
    'displayTypeHtml' : '<div class="collection-view"><a href="{{gridUrl}}" class="bc-sf-filter-display-grid" title="Grid view" data-view="grid"><span class="icon icon-collection-view-grid"></span></a><a href={{listUrl}} class="bc-sf-filter-display-list" title="List view" data-view="list"><span class="icon icon-collection-view-list"></span></a></div>',

    // Breadcrumb Template
    'breadcrumbHtml': '<a href="/" title="' + bcSfFilterConfig.label.breadcrumb_home_link + '">' + bcSfFilterConfig.label.breadcrumb_home + '</a>' +
                      ' <span class="divider" aria-hidden="true">&rsaquo;</span>' +
                      ' {{currentCollection}}'
};

var index = 0;

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data) {
  // console.log(index);
  /*** Prepare data ***/
  var images = data.images_info;
  var soldOut = !data.available; // Check a product is out of stock
  var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  var priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0];
  if (getParam('variant') !== null && getParam('variant') != '') {
    var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];
        break;
      }
    }
  }
  /*** End Prepare data ***/

  // Get Template
  var itemHtml = bcSfFilterTemplate.productGridItemHtml;

  // Add a specific class for grid item
  var gridItemWidthClass = '';
  var imageSize = '600x600';
  var width = '',
    height = '';
  switch (bcSfFilterConfig.custom.products_per_row) {
    case 2:
      gridItemWidthClass = 'medium--one-half large--one-half';
      imageSize = '540x600';
      width = 540;
      height = 600;
      break;
    case 3:
      gridItemWidthClass = 'small--one-half medium--one-third large--one-third';
      imageSize = '345x550';
      width = 345;
      height = 550;
      break;
    case 4:
      gridItemWidthClass = 'small--one-half medium--one-quarter large--one-quarter';
      imageSize = '250x';
      width = 250;
      height = 225;
      break;
    case 5:
      gridItemWidthClass = 'small--one-half medium--one-fifth large--one-fifth';
      imageSize = '195x';
      width = 195;
      height = 125;
      break;
  }
  itemHtml = itemHtml.replace(/{{gridItemWidthClass}}/g, gridItemWidthClass);

  // Add soldOut class
  var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
  itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

  // Add onSale class
  var onSaleClass = onSale ? bcSfFilterTemplate.onSaleClass : '';
  itemHtml = itemHtml.replace(/{{onSaleClass}}/g, onSaleClass);

  // Add soldOut label
  var itemSoldOutLabelHtml = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : '';
  itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml);

  // Add Thumbnail
  var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], imageSize) : bcSfFilterConfig.general.no_image_url;
  itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

  // Add Price
  //     var itemPriceHtml = '<span class="h1 medium--left">';
  //     if (onSale) {
  //         itemPriceHtml += '<span class="visually-hidden">' + bcSfFilterConfig.label.sale_price  + '</span>';
  //     } else {
  //         itemPriceHtml += '<span class="visually-hidden">' + bcSfFilterConfig.label.regular_price + '</span>';
  //     }
  //     itemPriceHtml += buildPriceHtml(data.price_min);
  //     if (onSale && bcSfFilterConfig.custom.show_compare_at_price) {
  //         itemPriceHtml += ' <small><s><span class="visually-hidden">' + bcSfFilterConfig.label.regular_price + '</span>';
  //         itemPriceHtml += buildPriceHtml(data.compare_at_price_min);
  //         itemPriceHtml += '</s></small>';
  //     }
  //     itemPriceHtml += '</span>';
  //     if (onSale && bcSfFilterConfig.custom.product_show_saved_amount) {
  //         var class1 = bcSfFilterConfig.custom.show_compare_at_price ? ' medium--right ' : '';
  //         var class2 = bcSfFilterConfig.custom.product_reviews_enable ? ' has-reviews' : '';
  //         var savePrice = data.compare_at_price_min - data.price_min;
  //         if (bcsffilter.moneyFormat.indexOf('money') != -1) {
  //             savePrice = this.formatMoney(savePrice, this.moneyFormat);
  //         } else {
  //             if (savePrice > 1000) {
  //                 if (bcsffilter.moneyFormat.indexOf('{{amount}}') != -1 && bcsffilter.moneyFormat.indexOf('.') != -1) {
  //                     savePrice = this.formatMoney(savePrice, this.moneyFormat, true);
  //                 } else if (bcSfFilterConfig.shop.money_format.indexOf('{{amount}}') != -1) {
  //                     savePrice = this.formatMoney(savePrice, this.moneyFormat).split('.')[0];
  //                 } else if (bcSfFilterConfig.shop.money_format.indexOf('{{amount_with_comma_separator}}') != -1) {
  //                     savePrice = this.formatMoney(savePrice, this.moneyFormat).split(',')[0];
  //                 }
  //             } else {
  //                 savePrice = this.formatMoney(savePrice, this.moneyFormat, true);
  //             }
  //         }
  //         itemPriceHtml += '<span class="sale-tag' + class1 + class2 + '">';
  //         itemPriceHtml += bcSfFilterConfig.label.save_price.replace(/{{ saved_amount }}/g, savePrice);
  //         itemPriceHtml += '</span>';
  //     }
  //     itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

  //Add image
  var aspect_ratio = null;
  var itemImgHtml = '';
  if (images.length > 0) {
    aspect_ratio = images[0]['width'] / images[0]['height'];
    var max_width = width;
    var max_height = height;
    if (aspect_ratio < 1) {
      max_width = height * aspect_ratio;
      if (images[0]['height'] < height) {
        max_height = images[0]['height'];
        max_width = images[0]['width'];
      } else {
        max_height = height;
      }
    } else {
      max_height = width / aspect_ratio;
      if (images[0]['width'] < width) {
        max_height = images[0]['height'];
        max_width = images[0]['width'];
      } else {
        max_width = width;
      }
    }
    itemImgHtml += '<div class="lazyload__image-wrapper no-js" style="max-width:' + max_width + 'px">' +
      '<div style="padding-top:' + 1 / aspect_ratio * 100 + '%;">' +
      '<img class="lazyload no-js" data-src="' + this.getFeaturedImage(images, '{width}x') + '" ' +
      'data-widths="[125, 180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="' + aspect_ratio + '" ' +
      'data-sizes="auto" alt="{{itemTitle}}"' +
      '/>' +
      '</div>' +
      '</div>' +
      '<noscript>' +
      '<img src="' + this.getFeaturedImage(images, '580x') + '"' +
      'srcset="' + this.getFeaturedImage(images, '580x') + ' 1x, ' + this.getFeaturedImage(images, '580@2x') + ' 2x" ' +
      'alt="{{itemTitle}}" style="opacity:1;"' +
      '/>' +
      '</noscript>';
  } else {
    itemImgHtml += '<div>' +
      '<img src="' + bcSfFilterConfig.general.no_image_url + '"/>' +
      '</div>';
  }
  itemHtml = itemHtml.replace(/{{itemImg}}/g, itemImgHtml);

  // Add data json
  //     var self = this;
  //     var itemJson = {
  //       "id": data.id,
  //       "title": data.title,
  //       "handle": data.handle,
  //       "vendor": data.vendor,
  //       "variants": data.variants,
  //       "url": self.buildProductItemUrl(data),
  //       "options_with_values": data.options_with_values,
  //       "images": data.images,
  //       "available": data.available,
  //       "price_min": data.price_min,
  //      "price_max": data.price_max,
  //      "compare_at_price_min": data.compare_at_price_min,
  //      "compare_at_price_max": data.compare_at_price_max,
  //     };
  //     itemHtml = itemHtml.replace(/{{itemJson}}/g, JSON.stringify(itemJson));

  // Add opt show
  var otpShowHtml = '';
  for (var i in data.tags) {
    if (data.tags[i] == 'Restricted') {
      otpShowHtml = 'otp_hide';
      break;
    }
  }
  itemHtml = itemHtml.replace(/{{otpShow}}/g, otpShowHtml);

  // Add main attribute
  itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
  var langId = getLangId();
  var title = data.title;
  var metaTitle = this.getProductMetafield( data , langId , 'title' );
  if( metaTitle !== null)
    title = metaTitle;
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, title);
//   itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));
  index += 1;

  return itemHtml;
};

BCSfFilter.prototype.buildProductListItem = function(data) {
  /*** Prepare data ***/
  var images = data.images_info;
  //data.price_min *= 100, data.price_max *= 100, data.compare_at_price_min *= 100, data.compare_at_price_max *= 100; // Displaying price base on the policy of Shopify, have to multiple by 100
  var soldOut = !data.available; // Check a product is out of stock
  var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  var priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0];
  if (getParam('variant') !== null && getParam('variant') != '') {
    var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];
        break;
      }
    }
  }
  /*** End Prepare data ***/

  // Get Template
  var itemHtml = bcSfFilterTemplate.productListItemHtml;

  // Add soldOut class
  var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
  itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

  // Add onSale class
  var onSaleClass = onSale ? bcSfFilterTemplate.onSaleClass : '';
  itemHtml = itemHtml.replace(/{{onSaleClass}}/g, onSaleClass);

  // Add soldOut label
  var itemSoldOutLabelHtml = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : '';
  itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml);

  // Add Thumbnail
  var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], '600x600') : bcSfFilterConfig.general.no_image_url;
  itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

  // Add Price
  //     var itemPriceHtml = '<span class="h1 medium--left">';
  //     if (onSale) {
  //         itemPriceHtml += '<span class="visually-hidden">' + bcSfFilterConfig.label.sale_price  + '</span>';
  //     } else {
  //         itemPriceHtml += '<span class="visually-hidden">' + bcSfFilterConfig.label.regular_price + '</span>';
  //     }
  //     itemPriceHtml += buildPriceHtml(data.price_min);
  //     if (onSale && bcSfFilterConfig.custom.show_compare_at_price) {
  //         itemPriceHtml += ' <small><s><span class="visually-hidden">' + bcSfFilterConfig.label.regular_price + '</span>';
  //         itemPriceHtml += buildPriceHtml(data.compare_at_price_min);
  //         itemPriceHtml += '</s></small>';
  //     }
  //     itemPriceHtml += '</span>';
  //     if (onSale && bcSfFilterConfig.custom.product_show_saved_amount) {
  //         var class1 = bcSfFilterConfig.custom.show_compare_at_price ? ' medium--right ' : '';
  //         var class2 = bcSfFilterConfig.custom.product_reviews_enable ? ' has-reviews' : '';
  //         var savePrice = data.compare_at_price_min - data.price_min;
  //         if (bcsffilter.moneyFormat.indexOf('money') != -1) {
  //             savePrice = this.formatMoney(savePrice, this.moneyFormat);
  //         } else {
  //             if (savePrice > 1000) {
  //                 if (bcsffilter.moneyFormat.indexOf('{{amount}}') != -1 && bcsffilter.moneyFormat.indexOf('.') != -1) {
  //                     savePrice = this.formatMoney(savePrice, this.moneyFormat, true);
  //                 } else if (bcsffilter.moneyFormat.indexOf('{{amount}}') != -1) {
  //                     savePrice = this.formatMoney(savePrice, this.moneyFormat).split('.')[0];
  //                 } else if (bcsffilter.moneyFormat.indexOf('{{amount_with_comma_separator}}') != -1) {
  //                     savePrice = this.formatMoney(savePrice, this.moneyFormat).split(',')[0];
  //                 }
  //             } else {
  //                 savePrice = this.formatMoney(savePrice, this.moneyFormat, true);
  //             }
  //         }
  //         itemPriceHtml += '<span class="sale-tag' + class1 + class2 + '">';
  //         itemPriceHtml += bcSfFilterConfig.label.save_price.replace(/{{ saved_amount }}/g, savePrice);
  //         itemPriceHtml += '</span>';
  //     }
  //     itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

  // Description
  var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
  itemDescription = (itemDescription.split(" ")).length > 40 ? itemDescription.split(" ").splice(0, 40).join(" ") + '...' : itemDescription.split(" ").splice(0, 40).join(" ");
  itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);

  // Add main attribute
  var langId = getLangId();
  var title = data.title;
  var metaTitle = this.getProductMetafield( data , langId , 'title' );
  if( metaTitle !== null)
    title = metaTitle;
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, title);
//   itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

  return itemHtml;
};

// Add this function to bc-sf-filter.js
function getLangId() {
  var lang = $('#ly-languages-switcher').find('option:selected').val();
  // if (lang == 'ly33580') lang = 'langshop';
  return lang;
}

function buildPriceHtml(price) {
  var customPrice = bcsffilter.formatMoney(price);
  if (!bcSfFilterConfig.custom.show_dollar_symbol) {
    customPrice = bcsffilter.removeCurrencySymbol(customPrice)
  }
  if (!(bcsffilter.moneyFormat.indexOf('money') > -1 || bcsffilter.moneyFormat.indexOf('.') > -1)) {
    if (bcSfFilterConfig.custom.superscript_decimals) {
      if (bcsffilter.moneyFormat.indexOf('{{amount}}') !== -1 || bcsffilter.moneyFormat.indexOf('{{ amount }}') !== -1) {
        customPrice = customPrice.replace('.', '<sup>') + '</sup>';
      } else if (bcsffilter.moneyFormat.indexOf('{{amount_with_comma_separator}}') !== -1 || bcsffilter.moneyFormat.indexOf('{{ amount_with_comma_separator }}') !== -1) {
        customPrice = customPrice.replace(',', '<sup>') + '</sup>';
      }
    }
  }
  var html = '<small aria-hidden="true">' + customPrice + '</small>';
  html += '<span class="visually-hidden">' + bcsffilter.formatMoney(price) + '</span>';
  return html;
}

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
  // Get page info
  var currentPage = parseInt(this.queryParams.page);
  var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

  // If it has only one page, clear Pagination
  if (totalPage == 1) {
    jQ(this.selector.pagination).html('');
    return false;
  }

  if (this.getSettingValue('general.paginationType') == 'default') {
    var paginationHtml = bcSfFilterTemplate.paginateHtml;

    // Build Previous
    var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

    // Build Next
    var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

    // Create page items array
    var beforeCurrentPageArr = [];
    for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...');
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);

    var afterCurrentPageArr = [];
    for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push('...');
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }

    // Build page items
    var pageItemsHtml = '';
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage in pageArr) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

    jQ(this.selector.pagination).html(paginationHtml);
  }
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
  if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
    jQ(this.selector.topSorting).html('');

    var sortingArr = this.getSortingList();
    if (sortingArr) {
      // Build content
      var sortingItemsHtml = '';
      for (var k in sortingArr) {
        sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
      }
      var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      jQ(this.selector.topSorting).html(html);

      // Set current value
      jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
    }
  }
};

// Build Display type
BCSfFilter.prototype.buildFilterDisplayType = function() {
  if (jQ(this.selector.topDisplayType).length > 0) {
    var itemHtml = bcSfFilterTemplate.displayTypeHtml;
    itemHtml = itemHtml.replace(/{{gridUrl}}/g, this.buildToolbarLink('display', 'list', 'grid'));
    itemHtml = itemHtml.replace(/{{listUrl}}/g, this.buildToolbarLink('display', 'grid', 'list'));
    jQ(this.selector.topDisplayType).html(itemHtml);

    // Active current display type
    jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').removeClass('collection-view--active');
    jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').removeClass('collection-view--active');
    if (this.queryParams.display == 'list') {
      jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').addClass('collection-view--active');
    } else if (this.queryParams.display == 'grid') {
      jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').addClass('collection-view--active');
    }
  }
};

// Build Breadcrumb
BCSfFilter.prototype.buildBreadcrumb = function(colData, apiData) {
  if (bcSfFilterTemplate.hasOwnProperty('breadcrumbHtml')) {
    var breadcrumbHtml = bcSfFilterTemplate.breadcrumbHtml;
    var colInfo = colData.collection;
    var currentCollectionHtml = '';
    if (Array.isArray(bcSfFilterConfig.general.current_tags) && bcSfFilterConfig.general.current_tags.length > 0) {
      currentCollectionHtml += ' <a href="/collections/' + colInfo.handle + '">' + colInfo.title + '</a>';
      currentCollectionHtml += ' <span class="divider" aria-hidden="true">&rsaquo;</span>'
      currentCollectionHtml += ' <span>' + current_tags.join(' + ') + '</span>';
    } else {
      currentCollectionHtml += ' <span>' + colInfo.title + '</span>';
    }
    breadcrumbHtml = breadcrumbHtml.replace(/{{currentCollection}}/g, currentCollectionHtml);
    jQ('.breadcrumb').html(breadcrumbHtml);
  }
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
  var self = this;
  // Build Quick view data
  jQ(self.getSelector('products')).find(".product-grid-item").each(function(e) {
    var _this = jQ(this);
    var url = _this.attr("href");
    jQ.ajax({
      type: "GET",
      url: url + '?view=bc-sf-bold-price',
      success: function(data) {
        _this.find(".product-item--price").append(data);
        if (typeof DoublyGlobalCurrency !== 'undefined') {
          DoublyGlobalCurrency.convertAll(jQueryGrizzly('div.currency-switcher').find('li.selected').attr('data-value'));
        }
      }
    });
  });
};

// Build Additional Elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  index = 0;
  if (BOLD && BOLD.common && BOLD.common.eventEmitter) {
    BOLD.common.eventEmitter.emit("BOLD_CURRENCY_double_check");
  }
  $(document).ready(function() {
    if (typeof theme !== 'undefined' && theme.hasOwnProperty('Sections')) {
      var sections = new theme.Sections();
      sections.register('collection-template', theme.Collection);
    }
  });
  
  var langifyTranslatableSelector = jQ(this.getSelector('filterTree')).find('.bc-sf-filter-option-value');
  var langifyTranslatableTitleSelector = jQ(this.getSelector('filterTree')).find('.bc-sf-filter-block-title h3 span');
  langifyTranslatableSelector.addClass('translatable');
  langifyTranslatableTitleSelector.addClass('translatable');
};


// Build Default layout
function buildDefaultLink(a, b) { var c = window.location.href.split("?")[0]; return c += "?" + a + "=" + b } BCSfFilter.prototype.buildDefaultElements = function(a) { if (bcSfFilterConfig.general.hasOwnProperty("collection_count") && jQ("#bc-sf-filter-bottom-pagination").length > 0) { var b = bcSfFilterConfig.general.collection_count,
        c = parseInt(this.queryParams.page),
        d = Math.ceil(b / this.queryParams.limit); if (1 == d) return jQ(this.selector.pagination).html(""), !1; if ("default" == this.getSettingValue("general.paginationType")) { var e = bcSfFilterTemplate.paginateHtml,
          f = "";
        f = c > 1 ? bcSfFilterTemplate.hasOwnProperty("previousActiveHtml") ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousHtml : bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml") ? bcSfFilterTemplate.previousDisabledHtml : "", f = f.replace(/{{itemUrl}}/g, buildDefaultLink("page", c - 1)), e = e.replace(/{{previous}}/g, f); var g = "";
        g = c < d ? bcSfFilterTemplate.hasOwnProperty("nextActiveHtml") ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextHtml : bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml") ? bcSfFilterTemplate.nextDisabledHtml : "", g = g.replace(/{{itemUrl}}/g, buildDefaultLink("page", c + 1)), e = e.replace(/{{next}}/g, g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};

    // Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData=function(data){for(var k=0;k<data.length;k++){data[k]['images']=data[k]['images_info'];if(data[k]['images'].length>0){data[k]['featured_image']=data[k]['images'][0]}else{data[k]['featured_image']={src:bcSfFilterConfig.general.no_image_url,width:'',height:'',aspect_ratio:0}}data[k]['url']='/products/'+data[k].handle;var optionsArr=[];for(var i=0;i<data[k]['options_with_values'].length;i++){optionsArr.push(data[k]['options_with_values'][i]['name'])}data[k]['options']=optionsArr;data[k]['price_min']*=100,data[k]['price_max']*=100,data[k]['compare_at_price_min']*=100,data[k]['compare_at_price_max']*=100;data[k]['price']=data[k]['price_min'];data[k]['compare_at_price']=data[k]['compare_at_price_min'];data[k]['price_varies']=data[k]['price_min']!=data[k]['price_max'];var firstVariant=data[k]['variants'][0];if(getParam('variant')!==null&&getParam('variant')!=''){var paramVariant=data.variants.filter(function(e){return e.id==getParam('variant')});if(typeof paramVariant[0]!=='undefined')firstVariant=paramVariant[0]}else{for(var i=0;i<data[k]['variants'].length;i++){if(data[k]['variants'][i].available){firstVariant=data[k]['variants'][i];break}}}data[k]['selected_or_first_available_variant']=firstVariant;for(var i=0;i<data[k]['variants'].length;i++){var variantOptionArr=[];var count=1;var variant=data[k]['variants'][i];var variantOptions=variant['merged_options'];if(Array.isArray(variantOptions)){for(var j=0;j<variantOptions.length;j++){var temp=variantOptions[j].split(':');data[k]['variants'][i]['option'+(parseInt(j)+1)]=temp[1];data[k]['variants'][i]['option_'+temp[0]]=temp[1];variantOptionArr.push(temp[1])}data[k]['variants'][i]['options']=variantOptionArr}data[k]['variants'][i]['compare_at_price']=parseFloat(data[k]['variants'][i]['compare_at_price'])*100;data[k]['variants'][i]['price']=parseFloat(data[k]['variants'][i]['price'])*100}data[k]['description']=data[k]['content']=data[k]['body_html']}return data};

/* Start Fix version 2.3.2 */
BCSfFilter.prototype.addFilterTreeItem=function(e,r,t,i){e=jQ.parseHTML(e),i=void 0!==i?i:this.getSelector("filterTree");void 0!==r&&"before"==r?jQ(i+t).prepend(e):jQ(i+t).append(e)};
/* End Fix version 2.3.2 */

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};


BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem=function(html,iLabel,iValue,fOType,fOId,fOLabel,fODisplayType,fOSelectType,fOItemValue,fOData){var keepValuesStatic=fOData.hasOwnProperty("keepValuesStatic")?fOData.keepValuesStatic:false;if(fOType=="review_ratings"&&this.getSettingValue("general.ratingSelectionStyle")=="text"){var title=this.getReviewRatingsLabel(fOItemValue.from)}else{var title=this.customizeFilterOptionLabel(iLabel,fOData.prefix,fOType)}if(keepValuesStatic===true)var productNumber=null;else var productNumber=fOItemValue.hasOwnProperty("doc_count")?fOItemValue.doc_count:0;html=html.replace(/{{itemLabel}}/g,this.buildFilterOptionLabel(iLabel,productNumber,fOData));html=html.replace(/{{itemLink}}/g,this.buildFilterOptionLink(fOId,iValue,fOType,fODisplayType,fOSelectType,keepValuesStatic));html=html.replace(/{{itemValue}}/g,encodeURIParamValue(iValue));html=html.replace(/{{itemTitle}}/g,title);html=html.replace(/{{itemFunc}}/g,"onInteractWithFilterOptionValue(event, this, '"+fOType+"', '"+fODisplayType+"', '"+fOSelectType+"', '"+keepValuesStatic+"')");html=this.checkFilterOptionSelected(fOId,iValue,fOType,fODisplayType)?html.replace(/{{itemSelected}}/g,"selected"):html.replace(/{{itemSelected}}/g,"");var htmlElement=jQ(html);htmlElement.children().attr({"data-id":fOId,"data-value":encodeURIParamValue(iValue),"data-parent-label":fOLabel,"data-title":title,"data-count":productNumber});if(fOType!="collection"){htmlElement.children().attr("rel","nofollow")}if(fOType=="collection")htmlElement.children().attr("data-collection-scope",fOItemValue.key);return jQ(htmlElement)[0].outerHTML};
/* end-boost-2.4.8 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
